import type { Node as ProseMirrorNode } from 'prosemirror-model'
import type { EditorState } from 'prosemirror-state'

type TextSerializableNodeSpec = {
    toText?: (props: { node: ProseMirrorNode }) => unknown
}

const actionPromptLeafText = (node: ProseMirrorNode): string => {
    const toText = (node.type.spec as TextSerializableNodeSpec).toText
    if (typeof toText !== 'function') return ''

    const text = toText({ node })
    return typeof text === 'string' ? text : ''
}

const actionPromptTextBetween = (doc: ProseMirrorNode, from: number, to: number): string => {
    return doc.textBetween(from, to, '', actionPromptLeafText)
}

export const getSuffixPromptRange = (
    state: EditorState,
    range: { from: number; to: number },
): { from: number; promptContent: string } | null => {
    const $from = state.doc.resolve(range.from)
    const textBlockStart = $from.start()
    if (range.from <= textBlockStart) return null
    const textBlockEnd = $from.end()
    if (actionPromptTextBetween(state.doc, range.to, textBlockEnd).trim()) return null

    let captureStart = textBlockStart
    state.doc.nodesBetween(textBlockStart, range.from, (node, pos) => {
        if (node.type.name === 'actionTag') {
            captureStart = pos + node.nodeSize
        }
        return true
    })

    const nextChar = actionPromptTextBetween(
        state.doc,
        captureStart,
        Math.min(captureStart + 1, state.doc.content.size),
    )
    if (nextChar === ' ') {
        captureStart += 1
    }

    const textBeforeCommand = actionPromptTextBetween(state.doc, captureStart, range.from)
    const promptContent = textBeforeCommand.trim()
    if (!promptContent) return null
    const leadingWhitespaceLength = textBeforeCommand.length - textBeforeCommand.trimStart().length

    return {
        from: captureStart + leadingWhitespaceLength,
        promptContent,
    }
}
